import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const SidebarNavItem = ({ to, label, activeLabel, onClick, badge }) => {
    const { pathname } = useLocation();
    const isRouteMatch = pathname === to || pathname.startsWith(`${to}/`);
    const isActive = isRouteMatch || label === activeLabel;

    return (
        <Link
            to={to}
            onClick={onClick}
            className={`flex w-full items-center justify-between rounded-lg px-4 py-3 text-left transition ${
                isActive ? "bg-white text-slate-900 shadow-sm focus:outline-none" : "text-slate-400 hover:bg-white/70 focus:outline-none"
            }`}
        >
            <span>{label}</span>
            {badge > 0 && (
                <span className="inline-flex items-center justify-center rounded-full bg-primary px-1.5 py-0.5 text-[10px] font-bold text-white min-w-[18px]">
                    {badge}
                </span>
            )}
        </Link>
    );
};

export default SidebarNavItem;
